import type { ProcedureHealthEntry } from '@erp/rpc';

/** What the editor row shows for one bound SOP's recent health. */
export interface ProcedureHealthSummary {
  /** Succeeded / total recorded runs, or null when nothing ran. */
  runSuccessRate: number | null;
  runsTotal: number;
  tasksWithPull: number;
  waivers: number;
}

export function describeProcedureHealth(
  entry: ProcedureHealthEntry | undefined,
): ProcedureHealthSummary | null {
  if (!entry) return null;
  return {
    runSuccessRate:
      entry.runs.total > 0 ? entry.runs.succeeded / entry.runs.total : null,
    runsTotal: entry.runs.total,
    tasksWithPull: entry.tasksWithPull,
    waivers: entry.waivers,
  };
}
